export default __webpack_public_path__ + "static/media/ReportIcon-Cosmo-MS.d3430fd7.jpg";